// An acquired model can take minutes to open while its archive entry is extracted, and the
// component that started the open (the archive file modal) unmounts right away. The guard
// lives at module level so a newer open, or leaving the page the open targets, makes the
// stale result land nowhere instead of replacing what the viewer shows.
let pending = { token: 0, targetPathname: null }

export const beginAcquiredModelOpen = (targetPathname) => {
  pending = { token: pending.token + 1, targetPathname }
  return pending.token
}

export const isLatestAcquiredModelOpen = token => token === pending.token

export const finishAcquiredModelOpen = (token) => {
  if (isLatestAcquiredModelOpen(token)) {
    pending = { ...pending, targetPathname: null }
  }
}

export const discardAcquiredModelOpenUnlessOn = (pathname) => {
  if (pending.targetPathname != null && pending.targetPathname !== pathname) {
    pending = { token: pending.token + 1, targetPathname: null }
  }
}
